export interface Language {
  key: string; // ISO 639-1 codes
  flagCountyCodes: string[];
  label: string;
  name: string;
  hasInternationalization?: boolean;
}

const spanish: Language = {
  key: "es",
  flagCountyCodes: ["es", "co"],
  label: "Español",
  name: "Spanish",
  hasInternationalization: true,
};

const english: Language = {
  key: "en",
  flagCountyCodes: ["gb", "us"],
  label: "English",
  name: "English",
  hasInternationalization: true,
};

const french: Language = {
  key: "fr",
  flagCountyCodes: ["fr"],
  label: "Français",
  name: "French",
  hasInternationalization: true,
};

const german: Language = {
  key: "de",
  flagCountyCodes: ["de"],
  label: "Deutsch",
  name: "German",
};

const brazilianPortuguese: Language = {
  key: "pt",
  flagCountyCodes: ["br"],
  label: "Português (Brasil)",
  name: "Brazilian Portuguese",
};

const norwegian: Language = {
  key: "no",
  flagCountyCodes: ["no"],
  label: "Norsk",
  name: "Norwegian",
};

export const SupportedLanguages: Language[] = [
  english,
  spanish,
  french,
  german,
  brazilianPortuguese,
  norwegian,
];

export const getLanguageByKey = (key: string): Language => {
  return (
    SupportedLanguages.find((lang) => lang.key === key) || SupportedLanguages[0]
  );
};
